export const getRegExp = (text: string) => {
  const escapedText = text.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&')

  return new RegExp(escapedText, 'i')
}
